import React, { useState } from "react";

const AppContext = React.createContext();

export const AppProvider = ({ children }) => {
  const [selectedDistributor,  setSelectedDistributor]  = useState();
  const [loggedInAdmin,        setLoggedInAdmin]        = useState({});

  // ✅ Refresh par localStorage se distributor restore karo
  const [loggedInDistributor, setLoggedInDistributor] = useState(() => {
    const stored = localStorage.getItem("loggedInDistributor");
    return stored ? JSON.parse(stored) : {};
  });

  // const [baseUrl, setBaseUrl] = useState("http://127.0.0.1:8000/api");
  // const [baseUrlForImage, setBaseUrlForImage] = useState("http://127.0.0.1:8000/storage");

  const [baseUrl, setBaseUrl] = useState("https://milkyway.btsportfolio2026.com/backend/public/api");
  const [baseUrlForImage, setBaseUrlForImage] = useState("https://milkyway.btsportfolio2026.com/backend/public/storage");

  const storeSelectedDistributor = (sc) => {
    setSelectedDistributor(sc);
  };

  const storeLoggedInAdmin = (admin) => {
    setLoggedInAdmin(admin);
  };

  const storeLoggedInDistributor = (distributor) => {
    // ✅ context aur localStorage dono update karo
    setLoggedInDistributor(distributor);
    localStorage.setItem("loggedInDistributor", JSON.stringify(distributor));
  };

  return (
    <AppContext.Provider
      value={{
        selectedDistributor,
        storeSelectedDistributor,
        storeLoggedInAdmin,
        loggedInAdmin,
        storeLoggedInDistributor,
        loggedInDistributor,
        baseUrl,
        baseUrlForImage,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;